import { CtaLink } from "../ui/CtaLink";
import { motion } from "framer-motion";
import { useI18n } from "../i18n";
import bg from "../assets/meadows.png";

export function CtaValley() {
  const { t } = useI18n();
  return (
    <section className="relative min-h-[720px] overflow-hidden">
      <img src={bg} alt="valley" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 video-placeholder">
        {/* TODO: replace with <video autoPlay loop muted playsInline src="/valley.mp4" /> */}
        <span className="absolute bottom-4 left-4 text-white/40 text-[10px] tracking-widest">
          video placeholder · looped AI-generated valley
        </span>
      </div>
      <div className="absolute inset-x-0 top-0 h-[55%] bg-gradient-to-b from-[var(--color-cream)] via-[var(--color-cream)]/80 to-transparent pointer-events-none" />

      <div className="relative z-10 pt-32 text-center px-6">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="text-5xl md:text-6xl text-[var(--color-ink)]"
        >
          {t("cta.title")}
        </motion.h2>
        <p className="mt-4 text-[var(--color-muted)]">{t("cta.sub")}</p>
        <div className="mt-8 flex items-center justify-center gap-3 flex-wrap">
          <CtaLink cta="waitlist" block="cta_valley" to="/waitlist" className="pill-btn">{t("cta.btn")}</CtaLink>
          <CtaLink cta="survey" block="cta_valley" to="/survey" className="pill-outline">{t("hero.cta.survey")}</CtaLink>
        </div>
      </div>
    </section>
  );
}
